<template>
  <b-container fluid>
    <div class="overall-bg">
      <BacktoPage path="/Masters"></BacktoPage>
      <Headerlayout :headertext="$t('userManagement.codeTemplate.header')"
        :contenttext="$t('userManagement.codeTemplate.content')" />
    </div>
    <!-- <TextField  placeholder="" clearable name="" :id="$t('userManagement.branch.branchCode')" label=""
      :rules="{ required: true, alphanumeric: true }" :requiredIcon="false" :disabled="false" /> -->
    <div class="form-white-bg">
      <!-- <b-form @submit.prevent="IsSubmit"> -->

      <div>
        <div class="codetemptab">
          <TabView class="tabview-custom" ref="tabview4">
            <TabPanel :class="ItemTab">
              <template #header>
                <div @mousedown.prevent="TabClick(1)">
                  <i class="pi pi-align-left pe-3"></i>
                  <span>Masters</span>
                </div>
              </template>
              <div v-if="windowWidth > 545">
                <SkeletonTableLoader :columns="headers" :loading="loading" />
                <div class="table-width-80 pb-5" v-if="!loading">

                  <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines"
                    :rows="10" dataKey="Id" :rowHover="true" filterDisplay="menu" :filters="filters"
                    responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields" @row-click="">

                    <template v-slot:checkBoxSlot="{ data }">
                      <div class="align-items-center pt-2">
                        <Checkbox :inputId="`${data.Id}_read`" :name="`Read_${data.Id}`" v-model="data.CheckFlag"
                          value="true" @change="SingleCheckBoxOnchange()" />
                      </div>
                    </template>

                    <template v-slot:check>
                      <div class=" align-items-center pt-2">
                        <Checkbox :inputId="`_read`" :name="``" v-model="checkbox" value="true"
                          @change="CheckBoxOnchange(checkbox)" />
                      </div>

                    </template>
                    <template v-slot:preslot="{ data }">
                      <div class="my-2 label-d-none">
                        <TextField placeholder="" clearable name="" :id="`${data.Id}_prefix`" label=""
                          v-model="data.Prefix" :rules="{ required: true, alphanumeric: true }" :requiredIcon="false"
                          :disabled="false" />
                      </div>
                    </template>
                    <template v-slot:sufslot="{ data }">
                      <div class="label-d-none">
                        <TextField placeholder="" clearable name="" :id="`${data.Id}_suffix`" label=""
                          v-model="data.Suffix" :rules="{ required: true, alphanumeric: true }" :requiredIcon="false"
                          :disabled="false" />
                      </div>
                    </template>
                    <template v-slot:digitslot="{ data }">
                      <div class="label-d-none">
                        <TextField placeholder="" clearable name="" :id="`${data.Id}_noofdigits`" label=""
                          v-model="data.NoOfDigits" :rules="{ required: true, alphanumeric: true }"
                          :requiredIcon="false" :disabled="false" />
                      </div>
                    </template>
                    <template v-slot:valslot="{ data }">
                      <div class="label-d-none">
                        <TextField placeholder="" clearable name="" :id="`${data.Id}_startvalue`" label=""
                          v-model="data.StartValue" :rules="{ required: true, alphanumeric: true }"
                          :requiredIcon="false" :disabled="false" />
                      </div>
                    </template>
                    <template v-slot:currentvalslot="{ data }">
                      <div class="label-d-none">
                        <TextField placeholder="" clearable name="" :id="`${data.Id}_currentvalue`" label=""
                          v-model="data.CurrentValue" :rules="{ required: true, alphanumeric: true }"
                          :requiredIcon="false" :disabled="false" />
                      </div>
                    </template>

                    <template v-slot:IsYearWiseslot="{ data }">
                      <div class="IsYearWise-container">
                        <InputSwitch v-model="data.check" aria-label="Confirmation" @change="ischecked(data)" />
                        <div class="tablefield w-75 ms-2 label-d-none" v-if="data.check != null && data.check != ''">
                          <CustomDropDown v-model="data.IsYearWise" :items="optionDropdown.templateoption"
                            :id="`${data.Id}_isyearwise`" name="" label="" :rules="{ required: true }"
                            :required-icon="false" />
                        </div>
                      </div>
                    </template>
                  </Tableview>
                  <b-row>
                    <div class="d-flex flex-row-reverse mt-0">
                      <Footer @cancel="$router.back()" @save="submitMaster()" label="Save" :cancelhide="false" />
                    </div>
                  </b-row>
                </div>
              </div>
            </TabPanel>

            <TabPanel :class="ItemTab">
              <template #header>
                <div @mousedown.prevent="TabClick(2)">
                  <i class="pi pi-align-left pe-3"></i>
                  <span>Transactions</span>
                </div>
              </template>

              <div>
                <b-form @submit.prevent="IsSubmit()">
                  <b-row>
                    <b-col lg="4" md="4">
                      <div class="field p-2 mb-1">
                        <CustomDropDown v-model="StoreDropdown.StoreId" :items="StoreDropdown.StoreOption"
                          :id="$t('userManagement.creatUser.store')" :name="$t('userManagement.creatUser.store')"
                          :label="$t('userManagement.creatUser.store')" :rules="{ required: true }"
                          :required-icon="true" @update:modelValue="StoreOnChange" />
                      </div>
                    </b-col>
                  </b-row>
                  <div v-if="windowWidth > 545">
                    <SkeletonTableLoader :columns="headers" :loading="loading" />
                    <div class="table-width-80 bspace" v-if="!loading">
                      <!-- <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines"
                :rows="10" :rowHover="true" filterDisplay="menu" responsiveLayout="scroll" :columns="headers"
                :globalFilterFields="globalFilterFields" :filters="filters" :options="List" @row-click=""
                :totalRecords="rowsCount" :serialNumber="true" :selectionMode="true" v-model:selection="selectedProduct"
                @selection="selectedProductItem">
                <template v-slot:preslot="{ data }">
                          <div class="field label-d-none">
                            <TextField
                              placeholder=""
                              clearable
                              name=""
                              :id="$t('userManagement.branch.branchCode')"
                              label=""
                              v-model="data.Prefix"
                              :rules="{ required: true, alphanumeric: true }"
                              :requiredIcon="false"
                              :disabled="false"
                            />
                          </div>
                        </template>
                <template v-slot:sufslot="{ data }">
                          <div class="field label-d-none">
                            <TextField
                              placeholder=""
                              clearable
                              name=""
                              :id="$t('userManagement.branch.branchCode')"
                              label=""
                              v-model="data.Suffix"
                              :rules="{ required: true, alphanumeric: true }"
                              :requiredIcon="false"
                              :disabled="false"
                            />
                          </div>
                        </template>
                <template v-slot:digitslot="{ data }">
                          <div class="label-d-none">
                            <TextField
                              placeholder=""
                              clearable
                              name=""
                              :id="$t('userManagement.branch.branchCode')"
                              label=""
                              v-model="data.NoOfDigits"
                              :rules="{ required: true, alphanumeric: true }"
                              :requiredIcon="false"
                              :disabled="false"
                            />
                          </div>
                        </template>
                <template v-slot:valslot="{ data }">
                          <div class="label-d-none">
                            <TextField
                              placeholder=""
                              clearable
                              name=""
                              :id="$t('userManagement.branch.branchCode')"
                              label=""
                              v-model="data.StartValue"
                              :rules="{ required: true, alphanumeric: true }"
                              :requiredIcon="false"
                              :disabled="false"
                            />
                          </div>
                        </template>
                <template v-slot:currentvalslot="{ data }">
                          <div class="label-d-none">
                            <TextField
                              placeholder=""
                              clearable
                              name=""
                              :id="$t('userManagement.branch.branchCode')"
                              label=""
                              v-model="data.CurrentValue"
                              :rules="{ required: true, alphanumeric: true }"
                              :requiredIcon="false"
                              :disabled="false"
                            />
                          </div>
                        </template>

                <template v-slot:IsYearWiseslot="{ data }">
                          <div class="IsYearWise-container">
                            <InputSwitch
                              v-model="data.check"
                              aria-label="Confirmation"
                              @change="ischecked(data)"
                            />
                            <div
                              class="tablefield w-75 ms-2 label-d-none"
                              v-if="data.check != null && data.check != ''"
                            >
                              <CustomDropDown
                                v-model="data.IsYearWise"
                                :items="optionDropdown.templateoption"
                                :id="$t('userManagement.branch.organisation')"
                                name=""
                                label=""
                                :rules="{ required: true }"
                                :required-icon="false"
                              />
                            </div>
                          </div>
                        </template>
              </Tableview> -->
                      <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines"
                        :rows="10" dataKey="Id" :rowHover="true" filterDisplay="menu" :filters="filters"
                        responsiveLayout="scroll" :columns="headers" :globalFilterFields="globalFilterFields"
                        @row-click="">

                        <template v-slot:checkBoxSlot="{ data }">
                          <div class="align-items-center pt-2">
                            <Checkbox :inputId="`${data.Id}_read`" :name="`Read_${data.Id}`" v-model="data.CheckFlag"
                              value="true" @change="SingleCheckBoxOnchange()" />
                          </div>
                        </template>

                        <template v-slot:check>
                          <div class="align-items-center pt-2">
                            <Checkbox :inputId="`_read`" :name="``" v-model="checkbox" value="true"
                              @change="CheckBoxOnchange(checkbox)" />
                          </div>

                        </template>
                        <template v-slot:preslot="{ data }">
                          <div class="my-2 label-d-none">
                            <TextField placeholder="" clearable name="" :id="`${data.Id}_prefix`" label=""
                              v-model="data.Prefix" :rules="{ required: true, alphanumeric: true }"
                              :requiredIcon="false" :disabled="false" />
                          </div>
                        </template>
                        <template v-slot:sufslot="{ data }">
                          <div class="label-d-none">
                            <TextField placeholder="" clearable name="" :id="`${data.Id}_suffix`" label=""
                              v-model="data.Suffix" :rules="{ required: true, alphanumeric: true }"
                              :requiredIcon="false" :disabled="false" />
                          </div>
                        </template>
                        <template v-slot:digitslot="{ data }">
                          <div class="label-d-none">
                            <TextField placeholder="" clearable name="" :id="`${data.Id}_noofdigits`" label=""
                              v-model="data.NoOfDigits" :rules="{ required: true, alphanumeric: true }"
                              :requiredIcon="false" :disabled="false" />
                          </div>
                        </template>
                        <template v-slot:valslot="{ data }">
                          <div class="label-d-none">
                            <TextField placeholder="" clearable name="" :id="`${data.Id}_startvalue`" label=""
                              v-model="data.StartValue" :rules="{ required: true, alphanumeric: true }"
                              :requiredIcon="false" :disabled="false" />
                          </div>
                        </template>
                        <template v-slot:currentvalslot="{ data }">
                          <div class="label-d-none">
                            <TextField placeholder="" clearable name="" :id="`${data.Id}_currentvalue`" label=""
                              v-model="data.CurrentValue" :rules="{ required: true, alphanumeric: true }"
                              :requiredIcon="false" :disabled="false" />
                          </div>
                        </template>

                        <template v-slot:IsYearWiseslot="{ data }">
                          <div class="IsYearWise-container">
                            <InputSwitch v-model="data.check" aria-label="Confirmation" @change="ischecked(data)" />
                            <div class="tablefield w-75 ms-2 label-d-none"
                              v-if="data.check != null && data.check != ''">
                              <CustomDropDown v-model="data.IsYearWise" :items="optionDropdown.templateoption"
                                :id="`${data.Id}_isyearwise`" name="" label="" :rules="{ required: true }"
                                :required-icon="false" />
                            </div>
                          </div>
                        </template>
                      </Tableview>
                      <b-row>
                        <div class="d-flex flex-row-reverse mt-0 me-5">
                          <Footer @cancel="$router.back()" label="Save" :cancelhide="false" />
                        </div>
                      </b-row>
                    </div>
                  </div>
                </b-form>
              </div>
            </TabPanel>
          </TabView>
        </div>
      </div>
    </div>
  </b-container>
  <Toast />
  <CreatedSuccessully :visible="successPop" @ok="closetrigger()" />
</template>

<script lang="ts">
import { defineComponent, onMounted, ref, toRef } from "vue";
import Headerlayout from "../../../../components/Masters/HeaderLayout.vue";
import TextField from "../../../../components/FormComponents/TextInput.vue";
import { RouterLink, RouterView, useRouter } from "vue-router";
import EditConfirmation from "../../../../components/FormComponents/EditConfirmation.vue";
import DeletedSuccessfully from "../../../../components/FormComponents/DeletedSuccessfully.vue";
// import Tableview from "../../../../components/FormComponents/Table.vue";
// import Tableview from "../../../../components/FormComponents/NormalTable.vue";
import Tableview from "../../../../components/FormComponents/Table.vue";

import { useI18n } from "vue-i18n";
import { FilterMatchMode, FilterOperator } from "primevue/api";
import CustomDropDown from "../../../../components/FormComponents/Dropdown.vue";
import Footer from "../../../../components/FormComponents/Footer.vue";
import { useForm } from "vee-validate";
import BacktoPage from "../../../../components/FormComponents/BacktoMaster.vue";
import moment from "moment";
import MasterEmpty from "../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../components/FormComponents/Loader.vue";
import SkeletonTableLoader from "../../../../components/FormComponents/SkeletonTableLoader.vue";
import ActivatedSuccessfully from "../../../../components/FormComponents/ActivateSuccessfully.vue";
import InActivatedSuccessfully from "../../../../components/FormComponents/InActivateSuccessfully.vue";
import EntityMasterService from "../../../../modules/Inventory/Service/EntityMasterService";
import commonService from "../../../../modules/Inventory/Service/CommonService";
import CreatedSuccessully from "../../../../components/FormComponents/createdsuccessfully.vue";
import commonservice from "../../../../modules/Inventory/Service/StoreService";
import { useToast } from "primevue/usetoast";

export default defineComponent({
  components: {
    CreatedSuccessully,
    Footer,
    Tableview,
    Headerlayout,
    TextField,
    EditConfirmation,
    DeletedSuccessfully,
    ActivatedSuccessfully,
    InActivatedSuccessfully,
    CustomDropDown,
    BacktoPage,
    MasterEmpty,
    Loader,
    SkeletonTableLoader,
  },

  setup() {
    const menu = ref();
    const { handleSubmit, errors, resetForm, resetField } = useForm();
    const successPop = ref(false);
    let filteredList = ref();
    const ItemTab = ref("");
    const toast = useToast();

    let List = ref<ListItem[]>([]);
    const rowsCount = ref(0);
    let loading = ref(false);

    const isForm = ref({
      option: ref(),
      Id: 0,
    });

    const StoreDropdown = ref({
      StoreId: ref(),
      StoreOption: [],
    });

    let session: any = localStorage.getItem("UsersData");

    session = JSON.parse(session);
    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    const selectedProduct: any = ref([]);
    const selectedProductMaster: any = ref([]);

    const windowWidth = ref(window.innerWidth);

    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    const headers = [

      {
        header: "check",
        ShowMactchMode: false,
        slot: "checkBoxSlot",
        fieldDisplay: "false",
        sortable: false,
        checkfield: true,
        class: "filterdisplaynone last-column-position",
      },

      {
        header: "Form Name",
        field: "TypeName",
        slot: "TypeNameslot",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
      },
      {
        header: "Prefix",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass",
        slot: "preslot",
        fieldDisplay: "false",
        sortable: false,
        class: "filterdisplaynone last-column-position",
      },
      {
        header: "Suffix",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        slot: "sufslot",
        fieldDisplay: "false",
        sortable: false,
        class: "filterdisplaynone last-column-position",
      },
      {
        header: "No of Digits",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        slot: "digitslot",
        fieldDisplay: "false",
        sortable: false,
        class: "filterdisplaynone last-column-position",
      },
      {
        header: "Start Value",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        slot: "valslot",
        fieldDisplay: "false",
        sortable: false,
        class: "filterdisplaynone last-column-position",
      },
      {
        header: "Current Value",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor",
        slot: "currentvalslot",
        fieldDisplay: "false",
        sortable: false,
        class: "filterdisplaynone last-column-position",
      },
      {
        header: "Year Wise",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "bluecolor width250",
        slot: "IsYearWiseslot",
        fieldDisplay: "false",
        sortable: false,
        class: "width250 filterdisplaynone last-column-position",
      },
    ];

    const globalFilterFields = ref(headers.map((col) => col.field));
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      TypeNames: { value: null, matchMode: FilterMatchMode.IN, options: List },
      IsYearWise: { value: null, matchMode: FilterMatchMode.IN, options: List },
      StartValue: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      NoOfDegits: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      Suffix: { value: null, matchMode: FilterMatchMode.IN, options: List },
      Prefix: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
    };

    //Organisation Dropdown
    const optionDropdown = ref({
      Orgid: null,
      templateoption: [
        {
          name: "Date Month Year",
          value: 1,
        },
        {
          name: "Month Year",
          value: 2,
        },
        {
          name: "Year",
          value: 3,
        },
        {
          name: "Financial Year",
          value: 4,
        },
      ],
    });

    interface ListItem {
      check: boolean;
      isNew: boolean;
      isModified: boolean;
      isDeleted: boolean;
      isActive: number;
      modifiedAt: string;
      createdBy: number;
      modifiedBy: number;
      createdByName: string;
      entityId: number;
      entityOperationId: number;
      HospitalId: number;
      BranchId: number;
      id: number;
      typeName: string;
      prefix: string;
      suffix: string;
      noOfDigits: number;
      startValue: number;
      currentValue: number;
      IsYearWise: any;
      createdAt: string;
      yearType: number;
      currentDateValue: string;
      morningShiftStartTime: string;
      eveningShiftStartTime: string;
      morningShiftEndTime: string;
      eveningShiftEndTime: string;
      visitType: number;
      IsMaster: number;
      StoreId: number;
      SubModuleId: number;
      RowNumber: number;
      CheckFlag: boolean;
      IsChecked: boolean
    }
    let checkbox = ref(['false'])
    onMounted(() => {
      debugger;
      ReadyFunction();
    });

    async function ReadyFunction() {
      TabClick(1);
    }

    //Load Store Dropdown

    async function LoadStore() {
      debugger;
      try {
        const response = await commonservice.StoreDropDownListByUserId(
          session.UserId,
          HospitalId,
          session.Admin,
          BranchId
        );

        if (response["result"].length > 0) {
          StoreDropdown.value.StoreOption = response["result"]
            .filter((f) => f.IsActive == true)
            .map((item) => {
              item.name = item.Name;
              item.value = item.Id;
              return item;
            });
        }
      } catch (error) {
        alert(error);
      }
    }

    let TabValue = ref(0);
    async function TabClick(TabClickValue) {
      debugger;
      TabValue.value = TabClickValue;
      checkbox.value = ['false']
      loading.value = true;

      const getresponse = await commonService.CodeTemplateList(
        BranchId,
        session.OrganizationId,
        TabClickValue,
        TabClickValue == 1 ? 0 : Number(StoreDropdown.value.StoreId)
      );

      if (getresponse["result"].length > 0) {
        rowsCount.value = getresponse["result"].length;
      }

      List.value = getresponse["result"].map((item) => {
        item.CheckFlag = item.IsChecked == false ? [] : ['true'];
        return item
      });

      SingleCheckBoxOnchange()
      if (TabClickValue == 2) {
        await LoadStore();
      }

      List.value.forEach((item) => {
        item.check =
          item.IsYearWise != 0 ? (item.check = true) : (item.check = false);
        item.IsYearWise =
          item.IsYearWise == 0 ? (item.IsYearWise = null) : item.IsYearWise;

        item.yearType = 0;

        item.HospitalId = HospitalId;
        item.BranchId = TabClickValue == 1 ? 0 : BranchId;
        item.morningShiftStartTime = "";
        item.eveningShiftStartTime = "";
        item.morningShiftEndTime = "";
        item.eveningShiftEndTime = "";
        item.IsMaster = TabClickValue == 1 ? 1 : 2;
        item.visitType = 0;
        //item.StoreId = TabClickValue == 1 ? 0 : item.StoreId;
      });

      loading.value = false;
    }

    async function StoreOnChange(StoreId) {
      debugger;
      if (StoreId != 0 && StoreId != null && StoreId != undefined) {
        await TabClick(2);

        List.value.forEach((item) => {
          item.StoreId = Number(StoreDropdown.value.StoreId);
        });
        checkbox.value = ['false']
      }
    }

    async function submitMaster() {
      debugger;
      try {
        if (countCheckedItems() == 0) {
          toast.add({
            severity: "warn",
            summary: "",
            detail: `Please Select any Form`,
            life: 3000,
          });
          return false;
        }
        let result: any;
        let msg = "";
        filteredList.value = List.value.map((items) => {
          items.IsChecked = Array.isArray(items.CheckFlag) && items.CheckFlag.includes("true") ? true : false
          return items

        })
        // .filter(item =>
        //   Array.isArray(item.CheckFlag) && item.CheckFlag.includes("true")
        // )

        let i = 0;
        filteredList.value.forEach((item) => {
          item.IsYearWise = item.IsYearWise == null ? 0 : item.IsYearWise;
        });
        result = await commonService.CreateCodeTemplate(filteredList.value);

        msg = result["ErrorInfo"].ErrorCode;

        if (msg == null) {
          successPop.value = true;
          checkbox.value = ['false']
        }
      } catch (error) {
        console.log(error);
      }
    }

    const IsSubmit = handleSubmit(async (values) => {
      debugger
      try {
        if (countCheckedItems() == 0) {
          toast.add({
            severity: "warn",
            summary: "",
            detail: `Please Select any Form`,
            life: 3000,
          });
          return false;
        }
        let result: any;
        let msg = "";
        filteredList.value = List.value.map((items) => {
          items.IsChecked = Array.isArray(items.CheckFlag) && items.CheckFlag.includes("true") ? true : false
          return items

        })
        // .filter(item =>
        //   Array.isArray(item.CheckFlag) && item.CheckFlag.includes("true")
        // )

        let i = 0;
        filteredList.value.forEach((item) => {
          item.IsYearWise = item.IsYearWise == null ? 0 : item.IsYearWise;
        });
        result = await commonService.CreateCodeTemplate(filteredList.value);

        msg = result["ErrorInfo"].ErrorCode;

        if (msg == null) {
          successPop.value = true;
          checkbox.value = ['false']
        }
      } catch (error) {
        console.log(error);
      }
    });
    function countCheckedItems() {
      const count = List.value.filter(item =>
        Array.isArray(item.CheckFlag) && item.CheckFlag.includes("true")
      ).length;
      console.log("Checked count:", count);
      return count;
    }
    function ischecked(check) {
      if (check.check == false) {
        check.IsYearWise = null;
      }
    }

    function closetrigger() {
      successPop.value = false;
      TabValue.value == 1 ? TabClick(1) : TabClick(2);
    }

    function selectedProductItem(data) {
      debugger;
      selectedProduct.value = data;
    }
    function selectedProductItemMaster(data) {
      debugger;
      selectedProductMaster.value = data;
    }
    function CheckBoxOnchange(flag) {
      debugger;
      List.value.forEach(item => {
        item.CheckFlag = flag;
      });
    }
    function SingleCheckBoxOnchange() {
      debugger;

      if (countCheckedItems() === List.value.length) {
        checkbox.value = ['true'];
      }
      else {
        checkbox.value = ['false']
      }
    }

    return {
      selectedProductItemMaster,
      selectedProductMaster,
      selectedProductItem,
      selectedProduct,
      submitMaster,
      ItemTab,
      loading,
      closetrigger,
      successPop,
      filteredList,
      rowsCount,
      ischecked,
      IsSubmit,
      isForm,
      optionDropdown,
      List,
      headers,
      globalFilterFields,
      filters,
      menu,
      TabClick,
      StoreDropdown,
      StoreOnChange,
      windowWidth,
      checkbox,
      CheckBoxOnchange,
      SingleCheckBoxOnchange
    };
  },
});
</script>

<style lang="scss" scoped>
.filteravatar {
  background-color: #918291;
  color: #ffffff;
  margin-left: 10px;
}

.rolespermissionadd .addbtn {
  background-color: #3096ff !important;
  border: none !important;
  padding: 0.5rem 0.3rem !important;
  font-size: 14px;
}

.rolecard {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
}

.details-card .actionbtngrp {
  height: 100% !important;
  display: flex;
  flex-direction: column;
  justify-content: center;
  flex-wrap: wrap;
  align-content: center;
  margin-right: 10px;
}

.details-card {
  padding: 0px !important;
  margin: 10px !important;
  height: 80px !important;
}

.details-card .rolename {
  padding-left: 10px;

  h3 {
    color: #444444;
    font-size: 15px;
    text-transform: capitalize;
  }

  p {
    font-size: 13px;
    font-weight: 500;
    color: #999999;
  }
}

.IsYearWise-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.bspace {
  padding-bottom: 80px;
}
</style>
